import { useNavigate } from "react-router-dom";

export default function Today(){
  const nav = useNavigate();

  return (
    <div style={container}>
      <h1 style={title}>Today</h1>

      <div style={grid}>

        <div style={card}>
          <h3>🔥 Urgent</h3>
          <p style={muted}>No urgent items</p>
        </div>

        <div style={card}>
          <h3>⏰ Reminders</h3>
          <p style={muted}>No reminders for today</p>
        </div>

        <div style={card}>
          <h3>💸 Payments</h3>
          <p style={muted}>No payments due today</p>
        </div>

        <div style={{ ...card, gridColumn: "1 / -1" }}>
          <h3>⚡ Quick Actions</h3>

          <div style={actions}>
            <Action label="Finance" emoji="💰" onClick={()=>nav("/finance")} />
            <Action label="Planner" emoji="🗓" onClick={()=>nav("/planner")} />
            <Action label="Investments" emoji="📈" onClick={()=>nav("/investments")} />
            <Action label="Transactions" emoji="📄" onClick={()=>nav("/finance/transactions")} />
            <Action label="Notes" emoji="📝" onClick={()=>nav("/notes")} />
            <Action label="Quick Note" emoji="➕" onClick={()=>nav("/notes/new")} />
            <Action label="Files" onClick={()=>nav("/files")}/>
          </div>
        </div>

      </div>
    </div>
  );
}

function Action({ label, emoji, onClick }){
  return (
    <div onClick={onClick} style={actionCard}>
      <div style={{ fontSize:"22px" }}>{emoji}</div>
      <div style={{ fontWeight:"600" }}>{label}</div>
    </div>
  );
}

/* ---------- styles ---------- */

const container = {
  padding:"32px",
  maxWidth:"1100px",
  margin:"0 auto"
};

const title = {
  fontSize:"32px",
  fontWeight:"700",
  marginBottom:"24px"
};

const grid = {
  display:"grid",
  gridTemplateColumns:"repeat(auto-fit, minmax(260px, 1fr))",
  gap:"20px"
};

const card = {
  padding:"20px",
  borderRadius:"16px",
  background:"#ffffff",
  boxShadow:"0 10px 25px rgba(0,0,0,0.06)",
  border:"1px solid #f0f0f0",
};

const muted = {
  color:"#777",
  marginTop:"6px"
};

const actions = {
  display:"grid",
  gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))",
  gap:"14px",
  marginTop:"12px"
};

const actionCard = {
  padding:"14px",
  borderRadius:"12px",
  background:"#f8fafc",
  border:"1px solid #eaeaea",
  display:"flex",
  flexDirection:"column",
  alignItems:"center",
  justifyContent:"center",
  gap:"6px",
  cursor:"pointer",
  transition:"0.2s",
};
